import styled from 'styled-components';

export const ContainerCreditCardForm = styled.form`
  display: flex;
  flex: none;
  flex-direction: column;
  font-family: 'Libre Franklin', sans-serif;
  h2 {
    font-size: 5.866vw;
    font-weight: 700;
    margin: 0 0 4.266vw 0;
  }
`;

export const LoadingGif = styled.img`
  width: 50vw;
  height: 50vw;
  align-self: center;
`;

export const TitlePayment = styled.p`
  font-size: 5.866vw;
  font-weight: 700;
  margin: 5.066vw 0 1.6vw 0;
`;

export const ButtonPayment = styled.div`
  display: flex;
  flex: none;
  font-family: 'Libre Franklin', sans-serif;
  align-items: center;
  background-color: #000000;
  color: #ffffff;
  border-radius: 2.666vw;
  height: 13.333vw;
  width: 89.333vw;
  margin: 0 0 6.666vw 0;
  p {
    font-size: 4.266vw !important;
    font-weight: 400 !important;
    width: 40.533vw;
    margin-left: 1.84vw !important;
    color: #ffffff;
    background-color: transparent;
  }
  span {
    font-size: 3.466vw;
    font-weight: 400;
    margin: 0 0 0 16.266vw;
    color: #ffffff;
    background-color: transparent;
  }
`;

export const BackButton = styled.button`
  border: none;
  background-color: transparent;
  color: white;
  font-size: 4.466vw;
  font-family: 'Libre Franklin', sans-serif;
  font-weight: 400;
  margin-left: 20vw;
`;

export const CreditCardIcon = styled.img`
  width: 5.4vw;
  height: 4.2vw;
  margin-left: 4.24vw;
`;

export const SideBySide = styled.div`
  display: flex;
  flex: none;
  width: 89.333vw;
  align-items: flex-start;
  justify-content: space-between;
  background-color: transparent;
`;

export const ButtonFixedContinue = styled.button`
  display: flex;
  width: 89.333vw;
  height: 13.333vw;
  border-radius: 2.666vw;
  align-items: center;
  justify-content: center;
  font-size: 4.266vw;
  font-weight: 700;
  background-color: #000000;
  color: #ffffff;
  position: fixed;
  bottom: 29.666vw;
  box-shadow: 2.666vw 5.333vw 5.333vw 16vw white;
  z-index: 2;

  &:disabled {
    background-color: #e4e4e4;
    border: none;
  }
`;
